import { SanityCareers } from '../../types/generated/graphql-types'
import { CareersProps } from '../components/blocks/Careers'
import { Breakpoints } from '../utilities/breakpoints'
import { validImage } from '../utilities/imageFilters'
import { Presets } from '../utilities/imagePreset'
import { getImagePropsWithSources } from '../utilities/imagePropUtils'

export interface SanityCareersToCareersPropsArgs {
  careers: SanityCareers
  aspectRatio?: 'landscape' | 'portrait'
}

export const sanityCareersToCareersProps = (
  { image, items, title }: SanityCareers,
  aspectRatio: 'landscape' | 'portrait' = 'landscape'
): CareersProps => ({
  image: validImage(image)
    ? getImagePropsWithSources(
        image,
        aspectRatio === 'landscape' ? Presets.careersLandscape : Presets.careersPortrait,
        Breakpoints.tb,
        Breakpoints.md,
        Breakpoints.xl
      )
    : undefined,
  items:
    items?.map(item => ({
      text: item?.text ?? '',
      title: item?.title ?? '',
      linkUrl: item?.linkRef?.page?.path ?? '/',
    })) ?? [],
  title: title ?? '',
})
